import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import ajax from './ajax';

export default function clinicsMap() {
    return {
        init() {
            const apiKey = document.querySelector('meta[name="google-maps-api-key"]')?.content;

            if (!apiKey) return;

            const googleMapsLoader = new Loader({
                apiKey: apiKey,
                libraries: [''],
            });

            googleMapsLoader.load().then((google) => {
                const map = new google.maps.Map(this.$refs.map, {
                    disableDefaultUI: true,
                    zoom: 6,
                    center: {
                        lat: 39.8019,
                        lng: -8.0151,
                    },
                });

                ajax.get('clinics/markers').then(({ data }) => {
                    const infoWindow = new google.maps.InfoWindow();

                    const markers = data.map(({ name: title, url, latitude: lat, longitude: lng, infowindow }) => {
                        const marker = new google.maps.Marker({ position: { lat, lng } });

                        marker.addListener('click', () => {
                            infoWindow.setContent(infowindow);
                            infoWindow.open({ map, anchor: marker });
                        });

                        return marker;
                    });

                    new MarkerClusterer({ map, markers });
                });
            });
        },
    };
}
